import {
  deleteBusinessProfile,
  updateBusinessProfile,
} from '@store/business/BusinessProfileReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Delete from './Delete'
import Update from './Update'
import View from './View'

export const BusinessProfilForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.businessProfile)
  const dispatch = useAppDispatch()

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        update: Update,
        delete: Delete,
        view: View,
      }}
      handlers={{
        update: async (values) =>
          dispatch(updateBusinessProfile(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteBusinessProfile(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

BusinessProfilForm.displayName = 'BusinessProfilForm'

export default BusinessProfilForm
